import { render, staticRenderFns } from "./addTalentDialog.vue?vue&type=template&id=33855bc4&scoped=true"
import script from "./addTalentDialog.vue?vue&type=script&lang=js"
export * from "./addTalentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33855bc4",
  null
  
)

export default component.exports